export const LOAD_FACILITY_REVOLVING_TYPES_STARTED = "LOAD_FACILITY_REVOLVING_TYPES_STARTED";
export const LOAD_FACILITY_REVOLVING_TYPES_SUCCEEDED = "LOAD_FACILITY_REVOLVING_TYPES_SUCCEEDED";
export const LOAD_FACILITY_REVOLVING_TYPES_FAILED = "LOAD_FACILITY_REVOLVING_TYPES_FAILED";

export const LOAD_FACILITY_FLEXIBILITY_RULES_STARTED = "LOAD_FACILITY_FLEXIBILITY_RULES_STARTED";
export const LOAD_FACILITY_FLEXIBILITY_RULES_SUCCEEDED = "LOAD_FACILITY_FLEXIBILITY_RULES_SUCCEEDED";
export const LOAD_FACILITY_FLEXIBILITY_RULES_FAILED = "LOAD_FACILITY_FLEXIBILITY_RULES_FAILED";

export const LOAD_FACILITY_CREDIT_LINE_STATUSES_STARTED = "LOAD_FACILITY_CREDIT_LINE_STATUSES_STARTED";
export const LOAD_FACILITY_CREDIT_LINE_STATUSES_SUCCEEDED = "LOAD_FACILITY_CREDIT_LINE_STATUSES_SUCCEEDED";
export const LOAD_FACILITY_CREDIT_LINE_STATUSES_FAILED = "LOAD_FACILITY_CREDIT_LINE_STATUSES_FAILED";

export const LOAD_FACILITY_PURPOSES_FOR_APPLICATION_STARTED = "LOAD_FACILITY_PURPOSES_FOR_APPLICATION_STARTED";
export const LOAD_FACILITY_PURPOSES_FOR_APPLICATION_SUCCEEDED = "LOAD_FACILITY_PURPOSES_FOR_APPLICATION_SUCCEEDED";
export const LOAD_FACILITY_PURPOSES_FOR_APPLICATION_FAILED = "LOAD_FACILITY_PURPOSES_FOR_APPLICATION_FAILED";

export const LOAD_PARTNER_GROUPS_STARTED = "LOAD_PARTNER_GROUPS_STARTED";
export const LOAD_PARTNER_GROUPS_SUCCEEDED = "LOAD_PARTNER_GROUPS_SUCCEEDED";
export const LOAD_PARTNER_GROUPS_FAILED = "LOAD_PARTNER_GROUPS_FAILED";

export const SAVE_FACILITY_HEADER_STARTED = "SAVE_FACILITY_HEADER_STARTED";
export const SAVE_FACILITY_HEADER_SUCCEEDED = "SAVE_FACILITY_HEADER_SUCCEEDED";
export const SAVE_FACILITY_HEADER_FAILED = "SAVE_FACILITY_HEADER_FAILED";

export const LOAD_FACILITY_WARRANTIES_STARTED = "LOAD_FACILITY_WARRANTIES_STARTED";
export const LOAD_FACILITY_WARRANTIES_SUCCEEDED = "LOAD_FACILITY_WARRANTIES_SUCCEEDED";
export const LOAD_FACILITY_WARRANTIES_FAILED = "LOAD_FACILITY_WARRANTIES_FAILED";

export const LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_STARTED = "LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_STARTED";
export const LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_SUCCEEDED =
  "LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_SUCCEEDED";
export const LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_FAILED = "LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_FAILED";
